import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  createContext
} from 'react';
import deepmerge from 'deepmerge';

import { setFromSession } from 'wtb-utils';

const BetalingsserviceContext = createContext();

const defaultState = {
  accounts: [],
  banks: [],
  mainBanks: [],
  bankInfo: null,
  isManualProcess: false
};

const BetalingsserviceProvider = ({ children, initialState: state = {} }) => {
  const initialState = deepmerge(defaultState, state);

  const [ accounts, setAccounts ] = useState(initialState.accounts);
  const [ banks, setBanks ] = useState(initialState.banks);
  const [ mainBanks, setMainBanks ] = useState(initialState.mainBanks);
  const [ bankInfo, setBankInfo ] = useState(initialState.bankInfo);
  const [ isManualProcess, setIsManualProcess ] = useState(initialState.isManualProcess);

  const hasBankSelected = useCallback(
    () => bankInfo && bankInfo.bank && bankInfo.bank.name,
    [ bankInfo ]
  );
  const hasBankInfo = useCallback(
    () => bankInfo && bankInfo.accountNumber && bankInfo.clearingNumber,
    [ bankInfo ]
  );

  useEffect(() => {
    if (!bankInfo) return;

    setFromSession('bankInfo', JSON.stringify(bankInfo));
  }, [ bankInfo ]);

  const _setAccounts = (accs) => {
    const _accounts = accs.map((account) => {
      let { id } = account;

      if (!id) {
        if (account.accountNumber && account.clearingNumber) {
          id = `${account.accountNumber}-${account.clearingNumber}`;
        } else if (account.iban) {
          id = account.iban;
        }
      }

      return {
        ...account,
        id
      };
    });

    setAccounts(_accounts);
  };

  const _setIsManualProcess = (value) => {
    setFromSession('isManualAccount', value);

    setIsManualProcess(value);
  };

  return (
    <BetalingsserviceContext.Provider
      value={{
        accounts, setAccounts: _setAccounts,
        banks, setBanks,
        mainBanks, setMainBanks,
        bankInfo, setBankInfo,
        isManualProcess, setIsManualProcess: _setIsManualProcess,
        hasBankSelected,
        hasBankInfo
      }}
    >
      {children}
    </BetalingsserviceContext.Provider>
  );
};

const BetalingsserviceConsumer = BetalingsserviceContext.Consumer;

const useBetalingsserviceContext = () => {
  const context = useContext(BetalingsserviceContext);

  if (context === undefined) {
    throw new Error('useBetalingsserviceContext must be used within a BetalingsserviceProvider');
  }

  return context;
};

export {
  BetalingsserviceContext, BetalingsserviceProvider, BetalingsserviceConsumer, useBetalingsserviceContext
};
